module.exports = __webpack_public_path__ + "img/face-with-medical-mask.af39987b.png";